import Requester from '../Requester';

const getCourierBusinessRiders = (businessId) => {
    return Requester.makeRequest(Requester.methods.GET, "merchants/" + businessId + "/agents")
};


const getCourierRiderDeliveryHistory = (businessId, agentId) => {
    return Requester.makeRequest(Requester.GET, "merchants/" + businessId + "/agents/" + agentId + "/deliveries")
};

const getCourierStats = (businessId) => {
    return Requester.makeRequest(Requester.methods.GET, "merchants/" + businessId + "/stats")
};

const getRiderStats = (businessId, agentId) => {
    return Requester.makeRequest(Requester.methods.GET, "merchants/" + businessId + "/agents/" + agentId + "/stats")
};

const getCourierSettlementDetails = (businessId) => {
    return Requester.makeRequest(Requester.methods.GET, "merchants/" + businessId + "/settlement/details")
};

const createDeliveryAgent = (businessId, data) => {
    // {{BaseURL}}/api/v1/merchants/286fb624-99a7-444c-95b3-122f4365d960/agents
    return Requester.makeRequest(Requester.methods.POST, "merchants/" + businessId + "/agents", "", data)
};

const createCourierSettlementDetails = (businessId, data) => {
    return Requester.makeRequest(Requester.methods.POST, "merchants/" + businessId + "/settlement/details", "", data)
};

const getDeliveryDetailsById = (businessId, deliveryId) => {
    return Requester.makeRequest(Requester.methods.GET, "merchants/" + businessId + "/delivery/" + deliveryId);
};

const getBusinessInfo = (businessId, deliveryId) => {
    return Requester.makeRequest(Requester.methods.GET, "merchants/" + businessId);
};


export default {
    getCourierBusinessRiders: getCourierBusinessRiders,
    getCourierRiderDeliveryHistory: getCourierRiderDeliveryHistory,
    getCourierStats: getCourierStats,
    getRiderStats: getRiderStats,
    getDeliveryDetailsById: getDeliveryDetailsById,
    getCourierSettlementDetails: getCourierSettlementDetails,
    createCourierSettlementDetails: createCourierSettlementDetails,
    getBusinessInfo: getBusinessInfo,
    createDeliveryAgent: createDeliveryAgent
}
